<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { tableData } from './constants/dataAdvancedtable'
import * as axios from "axios";
const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';

/**
 * Advanced table component
 */
export default {
  page: {
    title: 'Sites',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      tableData: tableData,
      title: 'Config',
      items: [
        {
          text: 'Admin',
          href: '/',
        },
        {
          text: 'Configs',
          href: '/',
          active: true
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'age',
      sortDesc: false,
      fields: [
        { key: 'id', sortable: true },
        { key: 'domain', sortable: true },
        { key: 'whiteListed', sortable: true, class: 'cursor-pointer' },
        { key: 'stickyBottom', sortable: true, class: 'cursor-pointer' },
        { key: 'stickySides', sortable: true, class: 'cursor-pointer' },
        { key: 'carouselMode', sortable: true, class: 'cursor-pointer' },
      ],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.fetchData();
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1
    },
    async fetchData() {
      const fetchSitesResponse = await axios(DASHBOARD_API_URL + `config/sites`);
      this.tableData = fetchSitesResponse.data.sites;
    },
    async setConfig(configId, key, value, id) {
      try {
        const response = await axios({
          method: 'patch',
          url: DASHBOARD_API_URL + `config/sites`,
          data: {
            configId,
            key,
            value
          }
        });
        if (response.status === 200) {
          this.tableData.find(x => x.id === id)[key] = value;
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Sites</h4>
            <p class="text-muted font-13 mb-4"></p>
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(whiteListed)="data">
                   <span
                           v-if="data.item.isWhitelisted"
                           class="text-center"
                           @click="setConfig(data.item.config.id, 'isWhitelisted', false, data.item.id)"
                   >
                     <i class="fe-check text-success"></i>
                   </span>
                   <span v-else
                         @click="setConfig(data.item.config.id, 'isWhitelisted', true, data.item.id)"
                   >
                     <i class="fe-slash text-danger"></i>
                   </span>
                </template>
                <template v-slot:cell(stickySides)="data">
                  <span v-if="data.item.stickySides" @click="setConfig(data.item.config.id, 'stickySides', false, data.item.id)"> <i class="fe-check text-success"></i> </span>
                  <span v-else @click="setConfig(data.item.config.id, 'stickySides', true, data.item.id)"> <i class="fe-slash text-danger"></i> </span>
                </template>
                <template v-slot:cell(stickyBottom)="data">
                  <span v-if="data.item.stickyBottom" @click="setConfig(data.item.config.id, 'stickyBottom', false, data.item.id)"> <i class="fe-check text-success"></i> </span>
                  <span v-else @click="setConfig(data.item.config.id, 'stickyBottom', true, data.item.id)"> <i class="fe-slash text-danger"></i> </span>
                </template>
                <template v-slot:cell(carouselMode)="data">
                  <span v-if="data.item.carouselMode" @click="setConfig(data.item.config.id, 'carouselMode', false, data.item.id)"> <i class="fe-check text-success"></i> </span>
                  <span v-else @click="setConfig(data.item.config.id, 'carouselMode', true, data.item.id)"> <i class="fe-slash text-danger"></i> </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
